import { gatewayApi as api } from './gatewayApi';

// Types
export interface Component {
  id: string;
  Name: string;
  Description: string;
  UoMId?: string;
  Value: number;
  Cost?: number;
  UnitOfMeasurement?: string;
  Active: boolean;
  
  // Related entities
  UoM?: UoM;
  
  // Dates
  CreatedDate?: string;
  ModifiedDate?: string;
}

export interface UoM {
  Id: string;
  Name: string;
  Description?: string;
  Active: boolean;
}

export interface SearchComponentsRequest {
  pageNum?: number;
  pageSize?: number;
  sort?: string;
  filter?: {
    Active?: boolean;
    Name?: string;
    Description?: string;
    UoMId?: string;
    [key: string]: any;
  };
}

export interface SearchComponentsResponse {
  data: Component[];
  totalCount: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface CreateComponentRequest {
  Name: string;
  Description: string;
  UoMId?: string;
  Value: number;
  Cost?: number;
  UnitOfMeasurement?: string;
  Active?: boolean;
}

// Component API Service
export const componentApi = {
  // Component Management - Updated to match deployed endpoints
  getAllComponents: (params?: SearchComponentsRequest): Promise<SearchComponentsResponse> =>
    api.get('/component', { params }),

  getComponentById: (id: string): Promise<Component> =>
    api.get(`/component/${id}`),

  createComponent: (data: CreateComponentRequest): Promise<Component> =>
    api.post('/component', data),

  updateComponent: (data: Partial<Component>): Promise<Component> =>
    api.put('/component', data),

  deleteComponent: (id: string): Promise<void> =>
    api.delete(`/component/${id}`),

  searchComponents: (params: SearchComponentsRequest): Promise<SearchComponentsResponse> =>
    api.post('/component/search', params),

  // Dropdown Data - Updated to use correct endpoints
  getActiveUoMs: (): Promise<UoM[]> =>
    api.get('/uofm', { params: { filter: { Active: true }, page: 1, limit: 100 } }),

  // Validation utilities
  validateComponent: (component: Partial<Component>): string[] => {
    const errors: string[] = [];
    
    if (!component.Name?.trim()) {
      errors.push('Component Name is required');
    }
    
    if (!component.Description?.trim()) {
      errors.push('Description is required');
    }
    
    if (!component.Value || component.Value <= 0) {
      errors.push('Value must be greater than 0');
    }
    
    return errors;
  }
}; 